import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/app/layouts/default.vue").then(m => m.default || m)),
  optician: defineAsyncComponent(() => import("/app/layouts/optician.vue").then(m => m.default || m))
}